import { makeStyles } from '@material-ui/core/styles'
import { colors, nativeSelect } from 'src/components/app-ui'

const inputBase = {
  width: '100%',
  padding: '10px 12px',
  border: `1px solid ${colors.borderSoft}`,
  borderRadius: '8px',
  outline: 'none',
  background: '#FFFFFF',
  fontFamily: 'inherit',
  fontSize: '14px',
  color: colors.navy,
  '&:focus': {
    borderColor: colors.primary,
  },
}

/** Card + form field styles shared by the workspace tabs. */
const useFormStyles = makeStyles(theme => ({
  stack: {
    maxWidth: 880,
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: '18px',
    padding: '24px',
  },
  cardHead: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '16px',
  },
  cardTitle: {
    fontSize: '15px',
    fontWeight: 600,
    color: colors.navy,
  },
  cardDesc: {
    marginTop: 2,
    fontSize: '13px',
    lineHeight: 1.5,
    color: colors.muted,
  },
  divider: {
    height: 1,
    background: colors.border,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '16px',
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
    },
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    minWidth: 0,
    fontSize: '13px',
    fontWeight: 500,
    color: colors.navy,
  },
  hint: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: 1.5,
    color: colors.subtle,
  },
  input: inputBase,
  readOnly: {
    ...inputBase,
    background: colors.hover,
    color: colors.muted,
    fontFamily: 'ui-monospace, Menlo, monospace',
    fontSize: '13px',
  },
  select: {
    ...inputBase,
    ...nativeSelect,
    cursor: 'pointer',
  },
  inputWrap: {
    position: 'relative',
    display: 'flex',
  },
  eye: {
    position: 'absolute',
    top: '50%',
    right: 8,
    transform: 'translateY(-50%)',
    display: 'flex',
    padding: 4,
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    color: colors.subtle,
  },
  actions: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
  },
}))

export default useFormStyles
